import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {
  ContactUsComponent,
  NavigationComponent,
  PageNotFoundComponent, ThirdPartyDeterminationComponent, ViewerComponent
} from './components';
import {AuthGuard} from "./guards/auth.guard";
import {AuthBaseComponent, AuthLoginComponent, AuthRegisterComponent, AuthResetComponent} from "./components/auth";
import {HistoryComponent} from "./modules/shared/components";
import { ErrorComponent } from './components/error/error.component';
import { PublicLookupsResolver } from './resolvers/public-lookups.resolver';
import { PrivateLookupsResolver } from './resolvers/private-lookups.resolver';
import { PreviewComponent } from './modules/shared/components/preview/preview.component';
import { TestComponent } from './components/test/test.component';
import { VerifyEmailComponent } from './components/auth/verify-email/verify-email.component';
import { MfaComponent } from './components/auth/mfa/mfa.component';

const routes: Routes = [
  // {path: 'lobby', component: PageNotFoundComponent},
  // {path: 'terms-and-conditions', component: PageNotFoundComponent},
  {path: '', redirectTo: '/auth/login', pathMatch: 'full'},
  {path: 'not-found', component: PageNotFoundComponent},
  // {path: 'test', component: TestComponent},
  {path: 'error', component: ErrorComponent },
  {
    path: 'auth',
    component: AuthBaseComponent,
    resolve: { publicLookups: PublicLookupsResolver },
    children: [
      {path: 'login', component: AuthLoginComponent},
      {path: 'register', component: AuthRegisterComponent},
      {path: 'reset-password', component: AuthResetComponent},
      {path: 'verify-email', component: VerifyEmailComponent},
      {path: 'mfa', component: MfaComponent},
      {path: '', redirectTo: '/auth/login', pathMatch: 'full'},
      {path: '*', redirectTo: '/auth/login', pathMatch: 'full'},
      {path: '**', redirectTo: '/auth/login', pathMatch: 'full'}
    ]
  },
  { path: 'deal-preview/:dealId', component: PreviewComponent },
  {
    path: ':id',
    component: NavigationComponent,
    runGuardsAndResolvers: 'paramsChange',
    canActivate: [AuthGuard],
    resolve: {
      publicLookups: PublicLookupsResolver,
      privateLookups: PrivateLookupsResolver,
    },
    children: [
      {
        path: 'not-found',
        component: PageNotFoundComponent
      },
      { path: 'error',
        component: ErrorComponent
      },
      {
        path: 'contact-us',
        component: ContactUsComponent,
      },
      {
        path: 'regulatory',
        component: ThirdPartyDeterminationComponent,
      },
      // {
      //   path: 'pending-deals',
      //   component: PendingDealsComponent,
      // },
      // {
      //   path: 'live-deals',
      //   component: LiveDealsComponent,
      // },
      // {
      //   path: 'closed-deals',
      //   component: ClosedDealsComponent,
      // },
      {
        path: 'deal-preview/:dealId',
        component: PreviewComponent
      },
      {
        path: 'documents',
        children: [
          {path: ':id', component: ViewerComponent}
        ],
      },
      {
        path: 'history', children: [
          {path: ':assetType', component: HistoryComponent}
        ]
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./modules').then(m => m.DashboardModule),
      },
      {
        path: 'approvals',
        loadChildren: () => import('./modules').then(m => m.ApprovalsModule),
      },
      {
        path: 'business-units',
        loadChildren: () => import('./modules').then(m => m.BusinessUnitsModule),
      },
      {
        path: 'deals',
        loadChildren: () => import('./modules').then(m => m.DealsModule),
      },
      {
        path: 'mandates',
        loadChildren: () => import('./modules').then(m => m.MandatesModule),
      },
      {
        path: 'users',
        loadChildren: () => import('./modules').then(m => m.UsersModule),
      },
      {
        path: 'admin',
        loadChildren: () => import('./modules').then(m => m.AdminModule),
      },
      {
        path: 'settings',
        loadChildren: () => import('./modules').then(m => m.SettingsModule),
      },
      {
        path: 'legal',
        loadChildren: () => import('./modules').then(m => m.LegalModule),
      },
      {
        path: 'entities',
        loadChildren: () => import('./modules').then(m => m.EntitiesModule),
      },
      {
        path: 'kyc',
        loadChildren: () => import('./modules').then(m => m.KycModule),
      },
      {
        path: 'my-company',
        loadChildren: () => import('./modules').then(m => m.CompanyModule),
      },
      {
        path: 'marketing',
        loadChildren: () => import('./modules').then(m => m.MarketingModule),
      },
      // {path: '', redirectTo: 'deals', pathMatch: 'full'},
      {path: '*', redirectTo: 'dashboard', pathMatch: 'full'},
      {path: '**', redirectTo: 'dashboard', pathMatch: 'full'}
    ]
  },
  // {path: '*', redirectTo: '/not-found', pathMatch: 'full'},
  // {path: '**', redirectTo: '/not-found', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
